<template>
  <header class="default-header">
    <component
      :is="logoWrapperComponent"
      v-bind="logoWrapperBindings"
    >
      <TextLogo dark />
    </component>

    <button
      v-if="!disableMenuButton"
      class="default-header__menu-button"
      aria-label="menu"
      @click.prevent="openFlyIn"
    >
      <Icon
        class="default-header__menu-button-icon"
        name="custom:bars-solid"
        size="24"
      />
    </button>
    <div class="default-header__actions default-header__actions--desktop">
      <div
        v-if="!disableNavigation"
        class="default-header__action-links"
      >
        <NuxtLink
          class="default-header__link"
          :to="pricesLink"
        >
          {{ $t('prices_link') }}
        </NuxtLink>
        <NuxtLink
          class="default-header__link"
          :to="howItWorksLink"
        >
          {{ $t('how_it_works_link') }}
        </NuxtLink>
        <NuxtLink
          class="default-header__link"
          :to="eventDemoOrder"
        >
          {{ $t('demo_link') }}
        </NuxtLink>
        <NuxtLink
          class="default-header__link"
          :to="reviewsLink"
        >
          {{ $t('reviews') }}
        </NuxtLink>
      </div>
      <div class="default-header__action-buttons">
        <AppButton
          v-if="!disableNavigation"
          class="homepage-hero__button"
          smaller
          @click="startOrder({ 'package-id': 2 })"
        >
          {{ $t('start_sharing') }}
        </AppButton>
        <LanguageSwitch />
      </div>
    </div>
  </header>
</template>

<script setup>
  import { FLY_IN, GENERAL_NAVIGATION_FLY_IN } from '~/lib/constants/overlay'
  import NuxtLink from '#app/components/nuxt-link'

  const props = defineProps({
    disableHomepageLink: {
      type: Boolean,
      default: false,
    },
    disableMenuButton: {
      type: Boolean,
      default: false,
    },
    disableNavigation: {
      type: Boolean,
      default: false,
    },
  })

  const overlayService = useOverlayService()
  const { t: $t } = useI18n()

  const { startOrder, homepageLink, pricesLink, howItWorksLink, reviewsLink, eventDemoOrder } = useLinks()

  const logoWrapperComponent = computed(() => (props.disableHomepageLink ? 'span' : NuxtLink))
  const logoWrapperBindings = computed(() => (props.disableHomepageLink ? {} : { to: homepageLink }))

  function openFlyIn() {
    overlayService.setCurrentOverlay({
      settings: {
        type: FLY_IN,
        component: GENERAL_NAVIGATION_FLY_IN,
        options: {
          transitionOrigin: 'right',
        },
      },
    })
  }
</script>

<style lang="scss">
  :root {
    --default-header-height: 72px;

    @include breakpoint(desktop) {
      --default-header-height: 76px;
    }
  }

  .default-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: var(--default-header-height);
  }

  .default-header__menu-button-icon {
    margin: 0 0 0 auto;
    color: var(--color-primary);

    @include breakpoint(desktop) {
      display: none;
    }
  }

  .default-header__actions {
    display: none;

    @include breakpoint(desktop) {
      margin: 0 0 0 auto;
      display: flex;
      align-items: center;
      gap: 24px;
    }
  }

  .default-header__action-links {
    display: flex;
    align-content: center;
    gap: 24px;
  }

  .default-header__link {
    color: var(--color-primary);
    font-weight: 700;
    transition: 0.2s color ease-in-out;
  }

  .default-header__link:hover {
    color: var(--color-secondary);
  }

  .default-header__action-buttons {
    display: flex;
    align-items: center;
    gap: 10px;
  }
</style>
